import { render, staticRenderFns } from "./SelectTree.vue?vue&type=template&id=2c4853be"
import script from "./SelectTree.vue?vue&type=script&lang=js"
export * from "./SelectTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports